<template>

  <div>
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="loading">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
      <div class="m-2">
       
        <garden-plan-form
            :on-submit="onSubmit"
            :tanks-area-items="TanksAreaItems"
            :fill-area-items="FillAreaItems"
              :irrigation-area-items="IrrigationAreaItems"
            :plan-data="planData"
            :errors="errors">
        </garden-plan-form>
      </div>
    </b-card>
    <b-row>
      <b-col cols="12" class="mt-5">
        <b-card no-body class="mb-0">
        <b-row>
          <b-col  cols="4">
            <CollapseableTimeLine  :params="{commentable:'plan',commentable_id:$route.params.id}"  class="mt-5"/>
          </b-col>
        </b-row>
        </b-card>
      
     </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormInvalidFeedback,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm,BFormGroup, BFormCheckboxGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import {computed, onUnmounted, ref, watch} from '@vue/composition-api'
import store from '@/store'
import PlanListAddNew from '@/views/modules/plans/garden-plan/plans-list/PlanListAddNew'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'
import { PlanStore } from "@/app/plans/garden/state";
import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import GardenPlanForm from '@/views/modules/plans/garden-plan/share/GardenPlanForm'
import router from '@/router'

import CollapseableTimeLine from '@core/components/app-timeline/CollapseableTimeLine.vue'

export default {
  components: {
    OrbitSpinner,AreaFormRepeater,flatPickr,BFormInvalidFeedback,
    BCard, BRow, BCol, BFormInput, BButton, BTable,BFormCheckboxGroup,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect, PlanListAddNew, BForm, BFormGroup,
    GardenPlanForm,CollapseableTimeLine
  },
  directives: {
    Ripple,
  },

  setup(props, {root}) {

    if (!store.hasModule('plans'))
      store.registerModule('plans', PlanStore)

    onUnmounted(() => {
      if (store.hasModule('plans'))
        store.commit('plans/RESET_STORE_DATA')
      store.unregisterModule('plans')
    })


    const FillAreaItems = ref([{
      id: 1,
      area: null,
      count: null
    }])
    const IrrigationAreaItems = ref([{
      id: 1,
      area: null,
      count:null
    
    }])


    const TanksAreaItems = ref([{
      id: 1,
      area: null,
      count: null
    }])


    const planData = computed(() => store.state.plans.data)
    const errors = computed(() => store.state.plans.errors)
    const loading = computed(() => store.state.plans.loading)


    store.dispatch('plans/getPlan', router.currentRoute.params.id).then(res => {
      
      FillAreaItems.value = res.data.fill_areas
      IrrigationAreaItems.value=res.data.irrigation
      TanksAreaItems.value = res.data.tanks
    })

    const onSubmit = () => {

     // store.commit('plans/SET_FILL_AREAS', FillAreaItems.value)
      store.commit('plans/SET_Irrigation_AREAS', IrrigationAreaItems.value)
      store.commit('plans/SET_TANK_AREAS', TanksAreaItems.value)

      store.dispatch('plans/updatePlan', router.currentRoute.params.id).then(res => {
        root.$bvToast.toast(root.$t('garden plan updated successfully'), {
          title: root.$t("success"),
          variant: 'success',
          solid: false,
        })
      }).catch(reason => {
        root.$bvToast.toast(root.$t(reason), {
          title: root.$t("Error"),
          variant: 'danger',
          solid: false,
        })
      })
    }

    return {
        IrrigationAreaItems,
      FillAreaItems,
      TanksAreaItems,
      onSubmit,
      loading,
      planData,
      errors,
    }

  }

}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';

.per-page-selector {
  width: 90px;
}
.actionIcon > button {
  padding: 0;
}
</style>
